export default __webpack_public_path__ + "static/media/README.c599c5e3.md";